import { Dialog } from 'primereact/dialog'
import utils from '../../utils'
import { Button } from 'primereact/button'
import { enums, icons } from '../../constants'
import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import LtsCurrency from '../../components/lottus/lts-currency'
import LtsCalendar from '../../components/lottus/lts-calendar'
import LtsDropdownIdValue from '../../components/lottus/lts-dropdown-id-value'
import LtsLookupContaCorrente from '../../components/lottus/lts-lookup-conta-corrente'

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function BaixarLancamentoModal(props) {
  const [valor, setValor] = useState(0)
  const [desconto, setDesconto] = useState(0)
  const [multa, setMulta] = useState(0)
  const [juros, setJuros] = useState(0)
  const [contaCorrente, setContaCorrente] = useState()
  const [unidade, setUnidade] = useState()
  const [data, setData] = useState(new Date())
  const [formaPagamento, setFormaPagamento] = useState()

  const formasPagamento = props.formasPagamento.filter(
    (fp) => fp.id !== enums.ID_FORMA_PAGTO_A_DEFINIR && fp.id !== enums.ID_FORMA_PAGTO_SEGURADORA
  )

  useEffect(() => {
    resetValues()
    initValores()
  }, [props.visible, props.descontosMultasJuros])

  useEffect(() => {
    atualizarValorTotal()
  }, [desconto, multa, juros, props.lancamentosBaixar])

  const getTotalLancamentos = () => {
    const lancamentos = _.get(props, 'lancamentosBaixar', [])
    const lancamento = lancamentos[0]
    let total = 0
    let campo = 'valor'
    const undiade = _.get(lancamento, 'unidade', null)
    if (undiade) {
      campo = 'valorBruto' // vindo do Contrato
    }
    lancamentos.map((l) => (total += _.get(l, campo, 0)))
    return total
  }

  const atualizarValorTotal = () => {
    let total = getTotalLancamentos()
    total = total + (multa + juros) - desconto
    setValor(total)
  }

  const initValores = () => {
    let total = getTotalLancamentos()
    const descontos = _.get(props, 'descontosMultasJuros.desconto', 0)
    const multa = _.get(props, 'descontosMultasJuros.multa', 0)
    const juros = _.get(props, 'descontosMultasJuros.juros', 0)
    setDesconto(descontos)
    setMulta(multa)
    setJuros(juros)

    const lancamentos = _.get(props, 'lancamentosBaixar', [])

    total = total + (multa + juros) - descontos
    setValor(total)
    if (!_.isEmpty(lancamentos)) {
      const lancamento = lancamentos[0]
      const undiade = _.get(lancamento, 'unidade', null)
      if (undiade) {
        setUnidade(unidade)
      } else {
        setUnidade({ id: lancamento['unidade_oid'], value: lancamento['unidade_sigla'] })
      }
      const contaCorrente = _.get(lancamento, 'contaCorrente', null)
      if (contaCorrente) {
        setContaCorrente(contaCorrente)
      } else {
        setContaCorrente({ id: lancamento['contaCorrente_oid'], value: lancamento['contaCorrente_descricao'] })
      }
    }
  }

  const isConfirmarDisabled = () => {
    return !(valor > 0) || !data || !formaPagamento || !utils.isIdValueIdValido(formaPagamento)
  }

  const onHide = () => {
    props.onHide()
  }

  const onConfirm = () => {
    props.onConfirm({
      desconto,
      multa,
      juros,
      oidContaCorrente: _.get(contaCorrente, 'id', null),
      valor,
      data,
      formaPagamento,
      lancamentos: _.get(props, 'lancamentosBaixar', []),
      container: props.container,
    })
    onHide()
  }

  const resetValues = () => {
    setValor(0)
    setDesconto(0)
    setMulta(0)
    setJuros(0)
    setContaCorrente(null)
    setData(new Date())
    setFormaPagamento(null)
    setUnidade(null)
  }

  return (
    <Dialog
      header={_.defaultTo(props.labelBaixar, 'Baixar')}
      visible={props.visible}
      onHide={() => {
        onHide()
      }}
      baseZIndex={1000000}
      modal={true}
      closable={true}
    >
      <div style={{ marginTop: '20px' }} className="p-grid p-fluid margin-top-dialogs">
        <div className="p-col-12 p-md-6">
          <div className="form-group p-col-12">
            <LtsCalendar
              className={'width-15-rem'}
              value={data}
              name={'data'}
              label={_.defaultTo(props.labelDataBaixa, 'Data Baixa')}
              onChange={(e) => setData(e)}
              disabled={props.bloquearLancamento}
            />
          </div>
          <div className="form-group p-col-12">
            <LtsDropdownIdValue
              name={'formaPagamentoBaixa'}
              value={formaPagamento}
              onChange={(e) => setFormaPagamento(e)}
              label={_.defaultTo(props.labelFormaPagamento, 'Forma de Pagamento')}
              style={{ width: '210px' }}
              options={formasPagamento}
            />
          </div>
          <div className="form-group p-col-12">
            <LtsLookupContaCorrente
              label={_.defaultTo(props.labelContaCorrente, 'Conta Corrente')}
              value={_.get(contaCorrente, 'value', '')}
              oidRecord={_.get(contaCorrente, 'id', '')}
              history={props.history}
              onChange={(e) => {
                const oid = _.get(e, 'oid', null)
                const descricao = _.get(e, 'descricao', '')
                setContaCorrente({ id: oid, value: descricao })
              }}
              unidade={unidade}
              editHidden={true}
            />
          </div>
          <div className="form-group p-col-12">
            <LtsCurrency
              className={'width-15-rem'}
              value={valor}
              name={'valorBaixa'}
              label={_.defaultTo(props.labelValorPago, 'Valor Pago')}
              onChange={(e) => setValor(e)}
              disabled={props.bloquearLancamento}
            />
          </div>
        </div>
        <div className="p-col-12 p-md-6">
          <div className="form-group p-col-12">
            <LtsCurrency
              className={'width-15-rem'}
              value={desconto}
              name={'valorDesconto'}
              label={_.defaultTo(props.labelDesconto, 'Desconto')}
              onChange={(e) => setDesconto(e)}
              disabled={props.bloquearLancamento}
            />
          </div>
          <div className="form-group p-col-12">
            <LtsCurrency
              className={'width-15-rem'}
              value={multa}
              name={'valorMulta'}
              label={_.defaultTo(props.labelMulta, 'Multa')}
              onChange={(e) => setMulta(e)}
              disabled={props.bloquearLancamento}
            />
          </div>
          <div className="form-group p-col-12">
            <LtsCurrency
              className={'width-15-rem'}
              value={juros}
              name={'valorMulta'}
              label={_.defaultTo(props.labelJuros, 'Juros')}
              onChange={(e) => setJuros(e)}
              disabled={props.bloquearLancamento}
            />
          </div>
        </div>
      </div>
      <div style={{ marginTop: '20px' }} className="p-grid form-group">
        <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
          <Button
            label={_.defaultTo(props.labelConfirmar, 'Confirmar')}
            onClick={() => {
              onConfirm()
            }}
            disabled={isConfirmarDisabled()}
            icon={icons.CHECK_ICON}
            className="p-button-success"
          />
        </div>
      </div>
    </Dialog>
  )
}
